import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DataContext } from "../../context/Data.context";
import { Separator } from "@moreirapontocom/npmhelpers";
import { connectToBluetoothDevice, isMobile } from "../../services/helpers";

const PairReader = () => {
  const _window: any = window.navigator;
  const [step, setStep] = useState(1);

  useEffect(() => {
    _checkNavigatorBluetoothAvailability();
    _detectMobileBrowser();
  }, []);

  const [isMobileBrowser, setIsMobileBrowser] = useState(false);
  const _detectMobileBrowser = () => {
    setIsMobileBrowser(isMobile());
  };

  const [bluetoothAvailable, setBluetoothAvailable] = useState(false);
  const _checkNavigatorBluetoothAvailability = async () => {
    try {
      // Method 1
      // if (!("bluetooth" in _window)) {
      //   console.log("Web Bluetooth API is not available.");
      //   return;
      // }
      // console.log("Web Bluetooth API is available.");

      // Method 2
      _window.bluetooth.getAvailability().then((available: any) => {
        if (available) {
          setBluetoothAvailable(true);
          return;
        }
        setBluetoothAvailable(false);
      });
    } catch (error: any) {
      console.log("Error: ", error);
      setBluetoothAvailable(false);
    }
  };

  const { data, setData } = useContext(DataContext);

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "Pair Reader",
        backButton: true,
        previousPage: "/readers",
      },
    });
  }, []);

  // const _disconnectDevice = async () => {
  //   setError(null);

  //   try {
  //     if (!bluetoothDevice) {
  //       return;
  //     }

  //     if (bluetoothDevice.gatt.connected) {
  //       bluetoothDevice.gatt.disconnect();
  //     } else {
  //       console.log('Already disconnected');
  //     }

  //     console.clear();

  //     setIsConnected(false);
  //   } catch (error: any) {
  //     console.log("Erro ao desconectar", error);
  //   }
  // };

  const [connectionResponse, setConnectionResponse] = useState({} as any);

  const _connectDevice = async () => {
    try {
      const response: any = await connectToBluetoothDevice();
      if (!response) {
        console.log("Error connecting device");
        setConnectionResponse({ error: "Error connecting device" });
        return;
      }

      console.log("RESPONSE", response);
      setData({
        ...data,
        selectedBluetoothDevice: response,
      });
      setConnectionResponse(response);
    } catch (error: any) {
      console.log("Error connecting device", error);
      setConnectionResponse({ error: error })
    }
  };

  /*
  const _disconnectDevice = async () => {
    // const response: any = await connectToBluetoothDevice(bluetoothDevice);
    console.log("To be implemented");
  };
  */

  return <>
    {isMobileBrowser && <>
      <div className="alert alert-danger">
        <small className="text-danger">
          <strong>
            <i className="fab fa-bluetooth text-danger me-2"></i> Bluetooth is not available for this browser.
          </strong>
          <br />
          Try using another browser or download the Metrix Reader app.
        </small>
      </div>

      <Separator size={20} />

      <div className="text-center">
        <small className="text-muted">
          Download the Metrix Reader app
        </small>
      </div>

      <Separator size={20} />

      <div className="row text-center">
        <div className="col">

          <a href="https://aptitudemedical.com" target="_blank" rel="noreferrer">
            <img src="images/apple-store.png" alt="Download for iOS" className="img-fluid" />
          </a>

        </div>
        <div className="col">

            <a href="https://aptitudemedical.com" target="_blank" rel="noreferrer">
              <img src="images/google-play.png" alt="Download for Android" className="img-fluid" />
            </a>

        </div>
      </div>
    </>}

    {!isMobileBrowser && <>
      {!bluetoothAvailable && <>
        <div className="alert alert-danger">
          <small className="text-danger">
            <strong>
              <i className="fab fa-bluetooth text-danger me-2"></i> Bluetooth is not available.
            </strong>
            <br />
            Try turn on your bluetooth device or use another browser.
          </small>
        </div>
      </>}

      {bluetoothAvailable && <>
        <Separator size={20} />

        {step === 1 && <>
          <div className="row text-center justify-content-center">
            <div className="col-6">
              <img src="images/reader-unplugged.png" alt="Metrix Reader" className="img-fluid" />
            </div>
          </div>

          <Separator size={20} />

          <div className="row justify-content-center">
            <div className="col-11">
              <h3>
                Gather your Metrix Reader and plug it in.
              </h3>
            </div>
          </div>

          <Separator size={20} />

          <div className="d-grid">
            <button
              onClick={() => setStep(2)}
              type="button"
              className="btn btn-primary btn-featured">
                Next
            </button>
          </div>
        </>}

        {step === 2 && <>
          <div className="row text-center justify-content-center">
            <div className="col-6">
              <img src="images/reader-plugged-in.png" alt="Metrix Reader" className="img-fluid" />
            </div>
          </div>

          <Separator size={20} />

          <div className="row justify-content-center">
            <div className="col-11">
              <h3>
                Once plugged and the middle light turns white, click "Next" to pair.
              </h3>
            </div>
          </div>

          <Separator size={20} />

          {connectionResponse.error && <div className="alert alert-danger mt-3 mb-3" role="alert">{JSON.stringify(connectionResponse.error, null, 2)}</div>}

          {connectionResponse.isConnected && <>
            <div className="alert alert-success">
              <small className="text-success">
                <div className="row align-items-center">
                  <div className="col">
                    <i className="fab fa-bluetooth me-2"></i> Connected to <strong>{connectionResponse.bluetoothDeviceDetails.name}</strong>
                  </div>
                  {/*
                  <div className="col-4 text-end">
                    <button
                      onClick={() => _disconnectDevice()}
                      className="btn btn-success btn-sm">
                        <i className="fas fa-times me-2"></i> Disconnect
                    </button>
                  </div>
                  */}
                </div>
              </small>
            </div>
          </>}

          <Separator size={20} />

          <div className="d-grid">

            {connectionResponse.isConnected && <>
              <Link to={"/listReaders"} type="button" className="btn btn-primary btn-featured">Finish</Link>
            </>}

            {!connectionResponse.isConnected && <>
              <button
                onClick={() => _connectDevice()}
                type="button"
                className="btn btn-primary btn-featured">
                  Next
              </button>
            </>}
          </div>
        </>}

      </>}
    </>}
  </>
};

export default PairReader;